<template lang="pug">
span

  v-btn(
      :disabled="disabledAction"
      @click="showModalHandler" 
      :loading="loading"
      x-small
      color="primary"
      icon
    ) 
      v-icon mdi-delete
  confirmation-dialog(
    v-model="modalShowing"
    :title="modalTitle"
    :descr="modalText"
    @okBtnClicked="send"
    @failBtnClicked="reset"
    @click:outside="reset"
  )
</template>

<script>
import ErrMixin from "@/mixins/errors.mixin"
import { CBR_STATUS } from '../core/candidates-const'
export default {
  name: 'CandidateRemoveFromAcceptance',
  mixins: [ErrMixin],
  inject: ['svc'],

  props: {
    disabled: Boolean,
    status: String,
    ID: Number,
    newExchange: Boolean,
    newReserve: Boolean
  },

  data: () => ({
    loading: false,
    modalTitle: 'Remove from acceptance',
    modalText: 'Are you sure you want to remove from acceptance this Candidate?',
    modalShowing: false
  }),

  computed: {
    Svc() {
      return this.svc()
    },

    disabledAction() {
      if(this.disabled || this.status !== CBR_STATUS.ACCEPTED || this.newExchange || this.newReserve ) return true
      return false
    }
  },

  methods:{ 
    showModalHandler() {
      this.showConfirmation()
    },

    showConfirmation() {
      this.freeze()
      this.modalShowing = true
    },

    async send() {
      this.freeze()
      try {
        await this.Svc.removeFromAccept([this.ID])
        this.unFreeze()
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
      finally {
        this.unFreeze()
      }
    },

    freeze() {
      this.loading = true
    },

    unFreeze() {
      this.loading = false
    },

    reset() {
      this.unFreeze()
    }
  },

  components: {
    confirmationDialog: () => import('@/components/global/ConfirmationDialog.vue')
  }
}
</script>